//FIXME: Do we really need this?
$(document).on('AjaxElementLoad', 'select', function () {
  //If a dropdown is updated by ajax, select the first element.
  $(this).find('option:first').attr('selected', 'selected');
});
